import { numericMenu, panel } from 'instantsearch.js/es/widgets'
import {
  isCollapsed, panelClasses, templates, wrapHeading,
} from './panels'
import { numericClasses, numericItem } from './numeric'

export const panelNumeric = (container, attribute, label, items) => {
  if (!attribute) {
    console.error('Attribute is required for refinement widget')
    return null
  }
  return panel({
    templates: {
      header: wrapHeading(label),
      collapseButtonText: templates.collapseButtonText,
    },
    collapsed: ({ state }) =>
      isCollapsed(container),
    cssClasses: panelClasses,
  })(numericMenu)({
    container,
    attribute,
    items,
    templates: {
      item: numericItem,
    },
    cssClasses: numericClasses,
  })
}
